const MAX_MENU_DEPTH = 4

function itemTreeDepth (item) {

  if (!item) return 0

  const children = Array.isArray(item.children) ? item.children : []

  if (!children.length) return 1

  return 1 + children.reduce((deepest, child) => Math.max(deepest, itemTreeDepth(child)), 0)
}

function canPlaceMenuItem (item, targetDepth) {

  if (!item || !Number.isInteger(targetDepth) || targetDepth < 1) return false

  return targetDepth + itemTreeDepth(item) - 1 <= MAX_MENU_DEPTH
}

module.exports = canPlaceMenuItem
module.exports.MAX_MENU_DEPTH = MAX_MENU_DEPTH
module.exports.itemTreeDepth = itemTreeDepth
